import React from 'react';


export class LabeledTextarea extends React.Component {
    render() {
        const {
            label = '',
            value = '',
            placeholder = '',
            height = 'auto',
            onChange = (event) => {},
            onKeyDown = (event) => {},
            onBlur = (event) => {}
        } = this.props;
        
        return (
            <label className="imd-form-label">
                <span className="imd-text-light-gray">{label}</span>
                <textarea
                    className="imd-form-control imd-text-main"
                    style={{height: height}}
                    value={value}
                    placeholder={placeholder}
                    onChange={(event) => onChange(event)}
                    onKeyDown={(event) => onKeyDown(event)}
                    onBlur={(event) => onBlur(event)}
                />
            </label>
        );
    }
}
